import { Chip, ChipProps } from "@mui/material";

export type SHChipProps = ChipProps;
export const SHChip = (props: SHChipProps): JSX.Element => <Chip {...props} />;
